import { useState } from "react";
import { ClipboardPaste, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import CategoryPicker from "@/components/ledger/CategoryPicker";

export default function LedgerToolbar({ search, setSearch, filter, setFilter, categories, blankCount, accounts = [], selectedCount, onBulk, onPaste }) {
  const [bulkCat, setBulkCat] = useState(null);
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="relative">
        <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search description, notes, for, project…"
          className="pl-9 w-64" data-testid="ledger-search-input" />
      </div>
      <Select value={filter} onValueChange={setFilter}>
        <SelectTrigger className="w-52" data-testid="ledger-filter-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All rows</SelectItem>
          <SelectItem value="blank">Blank category ({blankCount})</SelectItem>
          <SelectItem value="received">Received only</SelectItem>
          <SelectItem value="spent">Spent only</SelectItem>
          <SelectItem value="outside">Date outside FY</SelectItem>
          <SelectItem value="mismatch">Category type mismatch</SelectItem>
          {accounts.map((a) => <SelectItem key={a} value={`acct:${a}`}>From {a}</SelectItem>)}
          {(categories || []).map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
        </SelectContent>
      </Select>
      {blankCount > 0 && (
        <button type="button" onClick={() => setFilter("blank")} data-testid="ledger-blank-count"
          className="text-xs px-2 py-1 border border-amber-500/40 bg-amber-500/10 text-amber-300">
          {blankCount} uncategorised
        </button>
      )}
      {selectedCount > 0 && (
        <div className="flex items-center gap-2 border border-border bg-card px-2 py-1" data-testid="ledger-bulk-bar">
          <span className="text-xs text-muted-foreground">{selectedCount} selected · set category</span>
          <CategoryPicker value={bulkCat} onChange={setBulkCat} categories={categories} testId="ledger-bulk-category" className="w-44" />
          <Button size="sm" onClick={() => onBulk(bulkCat)} data-testid="ledger-bulk-apply">Apply</Button>
        </div>
      )}
      <Button variant="outline" className="ml-auto" onClick={onPaste} data-testid="ledger-paste-button">
        <ClipboardPaste className="h-4 w-4 mr-2" /> Paste from Excel
      </Button>
    </div>
  );
}
